import { Injectable } from '@angular/core';
import { IDetailViewFilter } from '../shared/models/detail-view-filter.interface';
import { DeviceLocationDeviceDetail } from '../shared/models/device-location-device-detail.interface';

@Injectable({
    providedIn: 'root'
})
export class DeviceDetailFiltersService {
    public static $name = 'deviceDetailFilterService';

    constructor() {}

    filterData(items: DeviceLocationDeviceDetail[], filter: IDetailViewFilter): DeviceLocationDeviceDetail[] {
        if (items == null) {
            return;
        }

        let filteredItems = items;

        if (filter.category) {
            filteredItems = filteredItems
                .filter(dev => dev.category === filter.category);
        }

        if (filter.wildcard) {
            const searchLower = filter.wildcard.toLowerCase();
            filteredItems = filteredItems
                .filter(dev =>
                    !dev.$nameLower ||
                    dev.$nameLower.indexOf(searchLower) >= 0 ||
                    dev.tag.toLowerCase().indexOf(searchLower) >= 0
                );
        }

        return filteredItems;
    };
}
